import React from 'react';
export * from './authContext.types';
import { IAuthContext } from './authContext.types';

export const AuthContext = React.createContext<IAuthContext>({
    gigyaAccount: { UID: 'test-uid' } as any,
    isLoggedIn: false,
    loading: false,
    setUser: () => {},
    user: null,
    isAuthenticated: false,
});
export default AuthContext;
